module.exports = __webpack_public_path__ + "static/media/hera.d7dbeac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hera.jpg
// module id = 736
// module chunks = 0